export const KEYCHAIN_URL = "https://x.cartridge.gg";
export const PROFILE_URL = "https://profile.cartridge.gg";
export const API_URL = "https://api.cartridge.gg";

// Query parameter name used to pass session data via URL redirects.
// Borrowed from Telegram mini app convention, but the choice is arbitrary.
export const REDIRECT_QUERY_NAME = "startapp";
